import React from 'react';

interface AlertBannerProps {
  message: string;
  variant?: 'warning' | 'error' | 'success';
}

const variants = {
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
  error:   'bg-rose-50 border-rose-200 text-rose-800',
  success: 'bg-emerald-50 border-emerald-200 text-emerald-800',
};

const dotColors = {
  warning: 'bg-amber-600',
  error:   'bg-rose-600',
  success: 'bg-emerald-600',
};

export const AlertBanner: React.FC<AlertBannerProps> = ({ message, variant = 'warning' }) => (
  <div className={`border px-4 py-3 rounded-xl text-xs flex items-center gap-2.5 ${variants[variant]}`}>
    <span className={`w-1.5 h-1.5 rounded-full animate-ping flex-shrink-0 ${dotColors[variant]}`} />
    <span>{message}</span>
  </div>
);
